import React, { useState } from 'react';
import { useIsTestCaseSimulatorEnabled } from './useIsTestCaseSimulatorEnabled';

type TestCaseSimulatorContextProps = {
  isTestCaseSimulatorOn: boolean;
  isEnabled: boolean;
  toggleTestCaseSimulator: () => void;
  shouldUseSimulatedData: boolean;
};

type TestCaseSimulatorProviderProps = {
  children: React.ReactNode;
};

const defaultContext = {
  isTestCaseSimulatorOn: false,
  isEnabled: false,
  toggleTestCaseSimulator: () => {},
  shouldUseSimulatedData: false,
};

const TestCaseSimulatorContext = React.createContext<
  TestCaseSimulatorContextProps
>(defaultContext);

export const useTestCaseSimulator = (): TestCaseSimulatorContextProps =>
  React.useContext(TestCaseSimulatorContext);

export const TestCaseSimulatorProvider = ({
  children,
}: TestCaseSimulatorProviderProps) => {
  const [isOn, setIsOn] = useState(false);
  const { isEnabled } = useIsTestCaseSimulatorEnabled();

  return (
    <TestCaseSimulatorContext.Provider
      value={{
        isTestCaseSimulatorOn: isOn,
        isEnabled,
        toggleTestCaseSimulator: () => setIsOn(!isOn),
        shouldUseSimulatedData: isEnabled && isOn,
      }}
    >
      {children}
    </TestCaseSimulatorContext.Provider>
  );
};
